import { solution_1 } from './solution-1'
import { solution_2 } from './solution-2'
import { solution_3 } from './solution-3'
import { solution_4 } from './solution-4'
import { solution_medical } from './medical'
import { solution_green_city } from './green-city'
import { solution_green_power_plant } from './green-power-plant'
import { solution_renewable_energy } from './renewable-energy'
export interface SolutionProps {
  id: number
  path: string
  title: string
  description?: string
  cover: string
  solutionCover: string
  banner: string
  solution?: string[]
  application?: { title: string; description?: string; image: string }[]
  product?: { title: string; description?: string; image: string }[]
  advantage?: string
  success_case?: { title: string; image: string }[]
}

const solutionEn: SolutionProps[] = [solution_2, solution_1, solution_3, solution_4]

const solutionCustomEn = [solution_medical, solution_green_city, solution_renewable_energy, solution_green_power_plant]

export const i18nSolution = {
  en: solutionEn,
  es: solutionEn,
  cn: solutionEn,
}

export const i18nSolutionCustom = {
  en: solutionCustomEn,
  es: solutionCustomEn,
  cn: solutionCustomEn,
}
